// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"medpoint-ya-bage_wrapper__eSulN","price":"medpoint-ya-bage_price__UVWfg"};